/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const ko_pricing_header_subtitle = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`개발자의 생산성을 극대화하는 EduSense의 다양한 플랜을 만나보세요. AI 기반 코딩 지원부터 팀 협업까지, 당신에게 맞는 플랜을 선택하세요.`)
};

const en_pricing_header_subtitle = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Discover EduSense's diverse plans to maximize developer productivity. From AI-powered coding assistance to team collaboration, choose the plan that suits you.`)
};

const ja_pricing_header_subtitle = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`開発者の生産性を最大化するEduSenseの多様なプランをご覧ください。AI駆動のコーディング支援からチーム協業まで、あなたに合ったプランを選択してください。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "ko" | "en" | "ja" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const pricing_header_subtitle = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.pricing_header_subtitle(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("pricing_header_subtitle", locale)
	if (locale === "ko") return ko_pricing_header_subtitle(inputs)
	if (locale === "en") return en_pricing_header_subtitle(inputs)
	return ja_pricing_header_subtitle(inputs)
};